export var ViewMode;
(function (ViewMode) {
    ViewMode["default"] = "default";
    ViewMode["button"] = "button";
})(ViewMode || (ViewMode = {}));
export var ColorUnit;
(function (ColorUnit) {
    ColorUnit["hex"] = "Hex";
    ColorUnit["r"] = "R";
    ColorUnit["g"] = "G";
    ColorUnit["b"] = "B";
    ColorUnit["a"] = "Alpha";
})(ColorUnit || (ColorUnit = {}));
